/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StorageAssetsRouteImport } from './routes/storage-assets'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PreviewSongsRouteImport } from './routes/preview/songs'
import { Route as PreviewLyricsRouteImport } from './routes/preview/lyrics'
import { Route as PreviewInstrumentalRouteImport } from './routes/preview/instrumental'
import { Route as PreviewFlashcardsRouteImport } from './routes/preview/flashcards'
import { Route as AppUploadRouteImport } from './routes/app/upload'
import { Route as AppSongsRouteImport } from './routes/app/songs'
import { Route as AppSongReviewRouteImport } from './routes/app/song-review'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppOnboardingRouteImport } from './routes/app/onboarding'
import { Route as AppMusicStylesRouteImport } from './routes/app/music-styles'
import { Route as AppLyricsRouteImport } from './routes/app/lyrics'
import { Route as AppInstrumentalRouteImport } from './routes/app/instrumental'
import { Route as AppFlashcardsRouteImport } from './routes/app/flashcards'
import { Route as AppFaqRouteImport } from './routes/app/faq'
import { Route as AppEditAllRouteImport } from './routes/app/edit-all'
import { Route as AppAudioReviewRouteImport } from './routes/app/audio-review'
import { Route as AdminTimestampProcessingRouteImport } from './routes/admin/timestamp-processing'
import { Route as PreviewScheduleIndexRouteImport } from './routes/preview/schedule/index'
import { Route as PreviewDecksIndexRouteImport } from './routes/preview/decks/index'
import { Route as AppSongsIndexRouteImport } from './routes/app/songs/index'
import { Route as AppScheduleIndexRouteImport } from './routes/app/schedule/index'
import { Route as AppDecksIndexRouteImport } from './routes/app/decks/index'
import { Route as PreviewScheduleCalendarRouteImport } from './routes/preview/schedule/calendar'
import { Route as PreviewFlashcardsCreateRouteImport } from './routes/preview/flashcards/create'
import { Route as PreviewDecksAddRouteImport } from './routes/preview/decks/add'
import { Route as AppSongsLibraryRouteImport } from './routes/app/songs/library'
import { Route as AppSongReviewSongIdRouteImport } from './routes/app/song-review.$songId'
import { Route as AppScheduleReviewRouteImport } from './routes/app/schedule/review'
import { Route as AppScheduleCalendarRouteImport } from './routes/app/schedule/calendar'
import { Route as AppScheduleAnalyticsRouteImport } from './routes/app/schedule/analytics'
import { Route as AppFlashcardsCreateRouteImport } from './routes/app/flashcards/create'
import { Route as AppEsBasicCreateRouteImport } from './routes/app/es-basic/create'
import { Route as AppDecksAddRouteImport } from './routes/app/decks/add'
import { Route as AppDecksDeckIdRouteImport } from './routes/app/decks/$deckId'
import { Route as AppSongsGenerationIdCreateFlashcardsRouteImport } from './routes/app/songs/$generationId.create-flashcards'

const StorageAssetsRoute = StorageAssetsRouteImport.update({
  id: '/storage-assets',
  path: '/storage-assets',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewSongsRoute = PreviewSongsRouteImport.update({
  id: '/preview/songs',
  path: '/preview/songs',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewLyricsRoute = PreviewLyricsRouteImport.update({
  id: '/preview/lyrics',
  path: '/preview/lyrics',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewInstrumentalRoute = PreviewInstrumentalRouteImport.update({
  id: '/preview/instrumental',
  path: '/preview/instrumental',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewFlashcardsRoute = PreviewFlashcardsRouteImport.update({
  id: '/preview/flashcards',
  path: '/preview/flashcards',
  getParentRoute: () => rootRouteImport,
} as any)
const AppUploadRoute = AppUploadRouteImport.update({
  id: '/app/upload',
  path: '/app/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSongsRoute = AppSongsRouteImport.update({
  id: '/app/songs',
  path: '/app/songs',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSongReviewRoute = AppSongReviewRouteImport.update({
  id: '/app/song-review',
  path: '/app/song-review',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/app/settings',
  path: '/app/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/app/onboarding',
  path: '/app/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMusicStylesRoute = AppMusicStylesRouteImport.update({
  id: '/app/music-styles',
  path: '/app/music-styles',
  getParentRoute: () => rootRouteImport,
} as any)
const AppLyricsRoute = AppLyricsRouteImport.update({
  id: '/app/lyrics',
  path: '/app/lyrics',
  getParentRoute: () => rootRouteImport,
} as any)
const AppInstrumentalRoute = AppInstrumentalRouteImport.update({
  id: '/app/instrumental',
  path: '/app/instrumental',
  getParentRoute: () => rootRouteImport,
} as any)
const AppFlashcardsRoute = AppFlashcardsRouteImport.update({
  id: '/app/flashcards',
  path: '/app/flashcards',
  getParentRoute: () => rootRouteImport,
} as any)
const AppFaqRoute = AppFaqRouteImport.update({
  id: '/app/faq',
  path: '/app/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const AppEditAllRoute = AppEditAllRouteImport.update({
  id: '/app/edit-all',
  path: '/app/edit-all',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAudioReviewRoute = AppAudioReviewRouteImport.update({
  id: '/app/audio-review',
  path: '/app/audio-review',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTimestampProcessingRoute =
  AdminTimestampProcessingRouteImport.update({
    id: '/admin/timestamp-processing',
    path: '/admin/timestamp-processing',
    getParentRoute: () => rootRouteImport,
  } as any)
const PreviewScheduleIndexRoute = PreviewScheduleIndexRouteImport.update({
  id: '/preview/schedule/',
  path: '/preview/schedule/',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewDecksIndexRoute = PreviewDecksIndexRouteImport.update({
  id: '/preview/decks/',
  path: '/preview/decks/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSongsIndexRoute = AppSongsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSongsRoute,
} as any)
const AppScheduleIndexRoute = AppScheduleIndexRouteImport.update({
  id: '/app/schedule/',
  path: '/app/schedule/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDecksIndexRoute = AppDecksIndexRouteImport.update({
  id: '/app/decks/',
  path: '/app/decks/',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewScheduleCalendarRoute = PreviewScheduleCalendarRouteImport.update({
  id: '/preview/schedule/calendar',
  path: '/preview/schedule/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewFlashcardsCreateRoute = PreviewFlashcardsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => PreviewFlashcardsRoute,
} as any)
const PreviewDecksAddRoute = PreviewDecksAddRouteImport.update({
  id: '/preview/decks/add',
  path: '/preview/decks/add',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSongsLibraryRoute = AppSongsLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => AppSongsRoute,
} as any)
const AppSongReviewSongIdRoute = AppSongReviewSongIdRouteImport.update({
  id: '/$songId',
  path: '/$songId',
  getParentRoute: () => AppSongReviewRoute,
} as any)
const AppScheduleReviewRoute = AppScheduleReviewRouteImport.update({
  id: '/app/schedule/review',
  path: '/app/schedule/review',
  getParentRoute: () => rootRouteImport,
} as any)
const AppScheduleCalendarRoute = AppScheduleCalendarRouteImport.update({
  id: '/app/schedule/calendar',
  path: '/app/schedule/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const AppScheduleAnalyticsRoute = AppScheduleAnalyticsRouteImport.update({
  id: '/app/schedule/analytics',
  path: '/app/schedule/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AppFlashcardsCreateRoute = AppFlashcardsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppFlashcardsRoute,
} as any)
const AppEsBasicCreateRoute = AppEsBasicCreateRouteImport.update({
  id: '/app/es-basic/create',
  path: '/app/es-basic/create',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDecksAddRoute = AppDecksAddRouteImport.update({
  id: '/app/decks/add',
  path: '/app/decks/add',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDecksDeckIdRoute = AppDecksDeckIdRouteImport.update({
  id: '/app/decks/$deckId',
  path: '/app/decks/$deckId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSongsGenerationIdCreateFlashcardsRoute =
  AppSongsGenerationIdCreateFlashcardsRouteImport.update({
    id: '/$generationId/create-flashcards',
    path: '/$generationId/create-flashcards',
    getParentRoute: () => AppSongsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/storage-assets': typeof StorageAssetsRoute
  '/admin/timestamp-processing': typeof AdminTimestampProcessingRoute
  '/app/audio-review': typeof AppAudioReviewRoute
  '/app/edit-all': typeof AppEditAllRoute
  '/app/faq': typeof AppFaqRoute
  '/app/flashcards': typeof AppFlashcardsRouteWithChildren
  '/app/instrumental': typeof AppInstrumentalRoute
  '/app/lyrics': typeof AppLyricsRoute
  '/app/music-styles': typeof AppMusicStylesRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/song-review': typeof AppSongReviewRouteWithChildren
  '/app/songs': typeof AppSongsRouteWithChildren
  '/app/upload': typeof AppUploadRoute
  '/preview/flashcards': typeof PreviewFlashcardsRouteWithChildren
  '/preview/instrumental': typeof PreviewInstrumentalRoute
  '/preview/lyrics': typeof PreviewLyricsRoute
  '/preview/songs': typeof PreviewSongsRoute
  '/app/decks/$deckId': typeof AppDecksDeckIdRoute
  '/app/decks/add': typeof AppDecksAddRoute
  '/app/es-basic/create': typeof AppEsBasicCreateRoute
  '/app/flashcards/create': typeof AppFlashcardsCreateRoute
  '/app/schedule/analytics': typeof AppScheduleAnalyticsRoute
  '/app/schedule/calendar': typeof AppScheduleCalendarRoute
  '/app/schedule/review': typeof AppScheduleReviewRoute
  '/app/song-review/$songId': typeof AppSongReviewSongIdRoute
  '/app/songs/library': typeof AppSongsLibraryRoute
  '/preview/decks/add': typeof PreviewDecksAddRoute
  '/preview/flashcards/create': typeof PreviewFlashcardsCreateRoute
  '/preview/schedule/calendar': typeof PreviewScheduleCalendarRoute
  '/app/decks': typeof AppDecksIndexRoute
  '/app/schedule': typeof AppScheduleIndexRoute
  '/app/songs/': typeof AppSongsIndexRoute
  '/preview/decks': typeof PreviewDecksIndexRoute
  '/preview/schedule': typeof PreviewScheduleIndexRoute
  '/app/songs/$generationId/create-flashcards': typeof AppSongsGenerationIdCreateFlashcardsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/storage-assets': typeof StorageAssetsRoute
  '/admin/timestamp-processing': typeof AdminTimestampProcessingRoute
  '/app/audio-review': typeof AppAudioReviewRoute
  '/app/edit-all': typeof AppEditAllRoute
  '/app/faq': typeof AppFaqRoute
  '/app/flashcards': typeof AppFlashcardsRouteWithChildren
  '/app/instrumental': typeof AppInstrumentalRoute
  '/app/lyrics': typeof AppLyricsRoute
  '/app/music-styles': typeof AppMusicStylesRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/song-review': typeof AppSongReviewRouteWithChildren
  '/app/upload': typeof AppUploadRoute
  '/preview/flashcards': typeof PreviewFlashcardsRouteWithChildren
  '/preview/instrumental': typeof PreviewInstrumentalRoute
  '/preview/lyrics': typeof PreviewLyricsRoute
  '/preview/songs': typeof PreviewSongsRoute
  '/app/decks/$deckId': typeof AppDecksDeckIdRoute
  '/app/decks/add': typeof AppDecksAddRoute
  '/app/es-basic/create': typeof AppEsBasicCreateRoute
  '/app/flashcards/create': typeof AppFlashcardsCreateRoute
  '/app/schedule/analytics': typeof AppScheduleAnalyticsRoute
  '/app/schedule/calendar': typeof AppScheduleCalendarRoute
  '/app/schedule/review': typeof AppScheduleReviewRoute
  '/app/song-review/$songId': typeof AppSongReviewSongIdRoute
  '/app/songs/library': typeof AppSongsLibraryRoute
  '/preview/decks/add': typeof PreviewDecksAddRoute
  '/preview/flashcards/create': typeof PreviewFlashcardsCreateRoute
  '/preview/schedule/calendar': typeof PreviewScheduleCalendarRoute
  '/app/decks': typeof AppDecksIndexRoute
  '/app/schedule': typeof AppScheduleIndexRoute
  '/app/songs': typeof AppSongsIndexRoute
  '/preview/decks': typeof PreviewDecksIndexRoute
  '/preview/schedule': typeof PreviewScheduleIndexRoute
  '/app/songs/$generationId/create-flashcards': typeof AppSongsGenerationIdCreateFlashcardsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/storage-assets': typeof StorageAssetsRoute
  '/admin/timestamp-processing': typeof AdminTimestampProcessingRoute
  '/app/audio-review': typeof AppAudioReviewRoute
  '/app/edit-all': typeof AppEditAllRoute
  '/app/faq': typeof AppFaqRoute
  '/app/flashcards': typeof AppFlashcardsRouteWithChildren
  '/app/instrumental': typeof AppInstrumentalRoute
  '/app/lyrics': typeof AppLyricsRoute
  '/app/music-styles': typeof AppMusicStylesRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/song-review': typeof AppSongReviewRouteWithChildren
  '/app/songs': typeof AppSongsRouteWithChildren
  '/app/upload': typeof AppUploadRoute
  '/preview/flashcards': typeof PreviewFlashcardsRouteWithChildren
  '/preview/instrumental': typeof PreviewInstrumentalRoute
  '/preview/lyrics': typeof PreviewLyricsRoute
  '/preview/songs': typeof PreviewSongsRoute
  '/app/decks/$deckId': typeof AppDecksDeckIdRoute
  '/app/decks/add': typeof AppDecksAddRoute
  '/app/es-basic/create': typeof AppEsBasicCreateRoute
  '/app/flashcards/create': typeof AppFlashcardsCreateRoute
  '/app/schedule/analytics': typeof AppScheduleAnalyticsRoute
  '/app/schedule/calendar': typeof AppScheduleCalendarRoute
  '/app/schedule/review': typeof AppScheduleReviewRoute
  '/app/song-review/$songId': typeof AppSongReviewSongIdRoute
  '/app/songs/library': typeof AppSongsLibraryRoute
  '/preview/decks/add': typeof PreviewDecksAddRoute
  '/preview/flashcards/create': typeof PreviewFlashcardsCreateRoute
  '/preview/schedule/calendar': typeof PreviewScheduleCalendarRoute
  '/app/decks/': typeof AppDecksIndexRoute
  '/app/schedule/': typeof AppScheduleIndexRoute
  '/app/songs/': typeof AppSongsIndexRoute
  '/preview/decks/': typeof PreviewDecksIndexRoute
  '/preview/schedule/': typeof PreviewScheduleIndexRoute
  '/app/songs/$generationId/create-flashcards': typeof AppSongsGenerationIdCreateFlashcardsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/dashboard'
    | '/faq'
    | '/storage-assets'
    | '/admin/timestamp-processing'
    | '/app/audio-review'
    | '/app/edit-all'
    | '/app/faq'
    | '/app/flashcards'
    | '/app/instrumental'
    | '/app/lyrics'
    | '/app/music-styles'
    | '/app/onboarding'
    | '/app/settings'
    | '/app/song-review'
    | '/app/songs'
    | '/app/upload'
    | '/preview/flashcards'
    | '/preview/instrumental'
    | '/preview/lyrics'
    | '/preview/songs'
    | '/app/decks/$deckId'
    | '/app/decks/add'
    | '/app/es-basic/create'
    | '/app/flashcards/create'
    | '/app/schedule/analytics'
    | '/app/schedule/calendar'
    | '/app/schedule/review'
    | '/app/song-review/$songId'
    | '/app/songs/library'
    | '/preview/decks/add'
    | '/preview/flashcards/create'
    | '/preview/schedule/calendar'
    | '/app/decks'
    | '/app/schedule'
    | '/app/songs/'
    | '/preview/decks'
    | '/preview/schedule'
    | '/app/songs/$generationId/create-flashcards'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/dashboard'
    | '/faq'
    | '/storage-assets'
    | '/admin/timestamp-processing'
    | '/app/audio-review'
    | '/app/edit-all'
    | '/app/faq'
    | '/app/flashcards'
    | '/app/instrumental'
    | '/app/lyrics'
    | '/app/music-styles'
    | '/app/onboarding'
    | '/app/settings'
    | '/app/song-review'
    | '/app/upload'
    | '/preview/flashcards'
    | '/preview/instrumental'
    | '/preview/lyrics'
    | '/preview/songs'
    | '/app/decks/$deckId'
    | '/app/decks/add'
    | '/app/es-basic/create'
    | '/app/flashcards/create'
    | '/app/schedule/analytics'
    | '/app/schedule/calendar'
    | '/app/schedule/review'
    | '/app/song-review/$songId'
    | '/app/songs/library'
    | '/preview/decks/add'
    | '/preview/flashcards/create'
    | '/preview/schedule/calendar'
    | '/app/decks'
    | '/app/schedule'
    | '/app/songs'
    | '/preview/decks'
    | '/preview/schedule'
    | '/app/songs/$generationId/create-flashcards'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/dashboard'
    | '/faq'
    | '/storage-assets'
    | '/admin/timestamp-processing'
    | '/app/audio-review'
    | '/app/edit-all'
    | '/app/faq'
    | '/app/flashcards'
    | '/app/instrumental'
    | '/app/lyrics'
    | '/app/music-styles'
    | '/app/onboarding'
    | '/app/settings'
    | '/app/song-review'
    | '/app/songs'
    | '/app/upload'
    | '/preview/flashcards'
    | '/preview/instrumental'
    | '/preview/lyrics'
    | '/preview/songs'
    | '/app/decks/$deckId'
    | '/app/decks/add'
    | '/app/es-basic/create'
    | '/app/flashcards/create'
    | '/app/schedule/analytics'
    | '/app/schedule/calendar'
    | '/app/schedule/review'
    | '/app/song-review/$songId'
    | '/app/songs/library'
    | '/preview/decks/add'
    | '/preview/flashcards/create'
    | '/preview/schedule/calendar'
    | '/app/decks/'
    | '/app/schedule/'
    | '/app/songs/'
    | '/preview/decks/'
    | '/preview/schedule/'
    | '/app/songs/$generationId/create-flashcards'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  DashboardRoute: typeof DashboardRoute
  FaqRoute: typeof FaqRoute
  StorageAssetsRoute: typeof StorageAssetsRoute
  AdminTimestampProcessingRoute: typeof AdminTimestampProcessingRoute
  AppAudioReviewRoute: typeof AppAudioReviewRoute
  AppEditAllRoute: typeof AppEditAllRoute
  AppFaqRoute: typeof AppFaqRoute
  AppFlashcardsRoute: typeof AppFlashcardsRouteWithChildren
  AppInstrumentalRoute: typeof AppInstrumentalRoute
  AppLyricsRoute: typeof AppLyricsRoute
  AppMusicStylesRoute: typeof AppMusicStylesRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSongReviewRoute: typeof AppSongReviewRouteWithChildren
  AppSongsRoute: typeof AppSongsRouteWithChildren
  AppUploadRoute: typeof AppUploadRoute
  PreviewFlashcardsRoute: typeof PreviewFlashcardsRouteWithChildren
  PreviewInstrumentalRoute: typeof PreviewInstrumentalRoute
  PreviewLyricsRoute: typeof PreviewLyricsRoute
  PreviewSongsRoute: typeof PreviewSongsRoute
  AppDecksDeckIdRoute: typeof AppDecksDeckIdRoute
  AppDecksAddRoute: typeof AppDecksAddRoute
  AppEsBasicCreateRoute: typeof AppEsBasicCreateRoute
  AppScheduleAnalyticsRoute: typeof AppScheduleAnalyticsRoute
  AppScheduleCalendarRoute: typeof AppScheduleCalendarRoute
  AppScheduleReviewRoute: typeof AppScheduleReviewRoute
  PreviewDecksAddRoute: typeof PreviewDecksAddRoute
  PreviewScheduleCalendarRoute: typeof PreviewScheduleCalendarRoute
  AppDecksIndexRoute: typeof AppDecksIndexRoute
  AppScheduleIndexRoute: typeof AppScheduleIndexRoute
  PreviewDecksIndexRoute: typeof PreviewDecksIndexRoute
  PreviewScheduleIndexRoute: typeof PreviewScheduleIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/storage-assets': {
      id: '/storage-assets'
      path: '/storage-assets'
      fullPath: '/storage-assets'
      preLoaderRoute: typeof StorageAssetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/songs': {
      id: '/preview/songs'
      path: '/preview/songs'
      fullPath: '/preview/songs'
      preLoaderRoute: typeof PreviewSongsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/lyrics': {
      id: '/preview/lyrics'
      path: '/preview/lyrics'
      fullPath: '/preview/lyrics'
      preLoaderRoute: typeof PreviewLyricsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/instrumental': {
      id: '/preview/instrumental'
      path: '/preview/instrumental'
      fullPath: '/preview/instrumental'
      preLoaderRoute: typeof PreviewInstrumentalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/flashcards': {
      id: '/preview/flashcards'
      path: '/preview/flashcards'
      fullPath: '/preview/flashcards'
      preLoaderRoute: typeof PreviewFlashcardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/upload': {
      id: '/app/upload'
      path: '/app/upload'
      fullPath: '/app/upload'
      preLoaderRoute: typeof AppUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/songs': {
      id: '/app/songs'
      path: '/app/songs'
      fullPath: '/app/songs'
      preLoaderRoute: typeof AppSongsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/song-review': {
      id: '/app/song-review'
      path: '/app/song-review'
      fullPath: '/app/song-review'
      preLoaderRoute: typeof AppSongReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/app/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/onboarding': {
      id: '/app/onboarding'
      path: '/app/onboarding'
      fullPath: '/app/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/music-styles': {
      id: '/app/music-styles'
      path: '/app/music-styles'
      fullPath: '/app/music-styles'
      preLoaderRoute: typeof AppMusicStylesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/lyrics': {
      id: '/app/lyrics'
      path: '/app/lyrics'
      fullPath: '/app/lyrics'
      preLoaderRoute: typeof AppLyricsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/instrumental': {
      id: '/app/instrumental'
      path: '/app/instrumental'
      fullPath: '/app/instrumental'
      preLoaderRoute: typeof AppInstrumentalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/flashcards': {
      id: '/app/flashcards'
      path: '/app/flashcards'
      fullPath: '/app/flashcards'
      preLoaderRoute: typeof AppFlashcardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/faq': {
      id: '/app/faq'
      path: '/app/faq'
      fullPath: '/app/faq'
      preLoaderRoute: typeof AppFaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/edit-all': {
      id: '/app/edit-all'
      path: '/app/edit-all'
      fullPath: '/app/edit-all'
      preLoaderRoute: typeof AppEditAllRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/audio-review': {
      id: '/app/audio-review'
      path: '/app/audio-review'
      fullPath: '/app/audio-review'
      preLoaderRoute: typeof AppAudioReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/timestamp-processing': {
      id: '/admin/timestamp-processing'
      path: '/admin/timestamp-processing'
      fullPath: '/admin/timestamp-processing'
      preLoaderRoute: typeof AdminTimestampProcessingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/schedule/': {
      id: '/preview/schedule/'
      path: '/preview/schedule'
      fullPath: '/preview/schedule'
      preLoaderRoute: typeof PreviewScheduleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/decks/': {
      id: '/preview/decks/'
      path: '/preview/decks'
      fullPath: '/preview/decks'
      preLoaderRoute: typeof PreviewDecksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/songs/': {
      id: '/app/songs/'
      path: '/'
      fullPath: '/app/songs/'
      preLoaderRoute: typeof AppSongsIndexRouteImport
      parentRoute: typeof AppSongsRoute
    }
    '/app/schedule/': {
      id: '/app/schedule/'
      path: '/app/schedule'
      fullPath: '/app/schedule'
      preLoaderRoute: typeof AppScheduleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/decks/': {
      id: '/app/decks/'
      path: '/app/decks'
      fullPath: '/app/decks'
      preLoaderRoute: typeof AppDecksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/schedule/calendar': {
      id: '/preview/schedule/calendar'
      path: '/preview/schedule/calendar'
      fullPath: '/preview/schedule/calendar'
      preLoaderRoute: typeof PreviewScheduleCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/flashcards/create': {
      id: '/preview/flashcards/create'
      path: '/create'
      fullPath: '/preview/flashcards/create'
      preLoaderRoute: typeof PreviewFlashcardsCreateRouteImport
      parentRoute: typeof PreviewFlashcardsRoute
    }
    '/preview/decks/add': {
      id: '/preview/decks/add'
      path: '/preview/decks/add'
      fullPath: '/preview/decks/add'
      preLoaderRoute: typeof PreviewDecksAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/songs/library': {
      id: '/app/songs/library'
      path: '/library'
      fullPath: '/app/songs/library'
      preLoaderRoute: typeof AppSongsLibraryRouteImport
      parentRoute: typeof AppSongsRoute
    }
    '/app/song-review/$songId': {
      id: '/app/song-review/$songId'
      path: '/$songId'
      fullPath: '/app/song-review/$songId'
      preLoaderRoute: typeof AppSongReviewSongIdRouteImport
      parentRoute: typeof AppSongReviewRoute
    }
    '/app/schedule/review': {
      id: '/app/schedule/review'
      path: '/app/schedule/review'
      fullPath: '/app/schedule/review'
      preLoaderRoute: typeof AppScheduleReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/schedule/calendar': {
      id: '/app/schedule/calendar'
      path: '/app/schedule/calendar'
      fullPath: '/app/schedule/calendar'
      preLoaderRoute: typeof AppScheduleCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/schedule/analytics': {
      id: '/app/schedule/analytics'
      path: '/app/schedule/analytics'
      fullPath: '/app/schedule/analytics'
      preLoaderRoute: typeof AppScheduleAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/flashcards/create': {
      id: '/app/flashcards/create'
      path: '/create'
      fullPath: '/app/flashcards/create'
      preLoaderRoute: typeof AppFlashcardsCreateRouteImport
      parentRoute: typeof AppFlashcardsRoute
    }
    '/app/es-basic/create': {
      id: '/app/es-basic/create'
      path: '/app/es-basic/create'
      fullPath: '/app/es-basic/create'
      preLoaderRoute: typeof AppEsBasicCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/decks/add': {
      id: '/app/decks/add'
      path: '/app/decks/add'
      fullPath: '/app/decks/add'
      preLoaderRoute: typeof AppDecksAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/decks/$deckId': {
      id: '/app/decks/$deckId'
      path: '/app/decks/$deckId'
      fullPath: '/app/decks/$deckId'
      preLoaderRoute: typeof AppDecksDeckIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/songs/$generationId/create-flashcards': {
      id: '/app/songs/$generationId/create-flashcards'
      path: '/$generationId/create-flashcards'
      fullPath: '/app/songs/$generationId/create-flashcards'
      preLoaderRoute: typeof AppSongsGenerationIdCreateFlashcardsRouteImport
      parentRoute: typeof AppSongsRoute
    }
  }
}

interface AppFlashcardsRouteChildren {
  AppFlashcardsCreateRoute: typeof AppFlashcardsCreateRoute
}

const AppFlashcardsRouteChildren: AppFlashcardsRouteChildren = {
  AppFlashcardsCreateRoute: AppFlashcardsCreateRoute,
}

const AppFlashcardsRouteWithChildren = AppFlashcardsRoute._addFileChildren(
  AppFlashcardsRouteChildren,
)

interface AppSongReviewRouteChildren {
  AppSongReviewSongIdRoute: typeof AppSongReviewSongIdRoute
}

const AppSongReviewRouteChildren: AppSongReviewRouteChildren = {
  AppSongReviewSongIdRoute: AppSongReviewSongIdRoute,
}

const AppSongReviewRouteWithChildren = AppSongReviewRoute._addFileChildren(
  AppSongReviewRouteChildren,
)

interface AppSongsRouteChildren {
  AppSongsLibraryRoute: typeof AppSongsLibraryRoute
  AppSongsIndexRoute: typeof AppSongsIndexRoute
  AppSongsGenerationIdCreateFlashcardsRoute: typeof AppSongsGenerationIdCreateFlashcardsRoute
}

const AppSongsRouteChildren: AppSongsRouteChildren = {
  AppSongsLibraryRoute: AppSongsLibraryRoute,
  AppSongsIndexRoute: AppSongsIndexRoute,
  AppSongsGenerationIdCreateFlashcardsRoute:
    AppSongsGenerationIdCreateFlashcardsRoute,
}

const AppSongsRouteWithChildren = AppSongsRoute._addFileChildren(
  AppSongsRouteChildren,
)

interface PreviewFlashcardsRouteChildren {
  PreviewFlashcardsCreateRoute: typeof PreviewFlashcardsCreateRoute
}

const PreviewFlashcardsRouteChildren: PreviewFlashcardsRouteChildren = {
  PreviewFlashcardsCreateRoute: PreviewFlashcardsCreateRoute,
}

const PreviewFlashcardsRouteWithChildren =
  PreviewFlashcardsRoute._addFileChildren(PreviewFlashcardsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  DashboardRoute: DashboardRoute,
  FaqRoute: FaqRoute,
  StorageAssetsRoute: StorageAssetsRoute,
  AdminTimestampProcessingRoute: AdminTimestampProcessingRoute,
  AppAudioReviewRoute: AppAudioReviewRoute,
  AppEditAllRoute: AppEditAllRoute,
  AppFaqRoute: AppFaqRoute,
  AppFlashcardsRoute: AppFlashcardsRouteWithChildren,
  AppInstrumentalRoute: AppInstrumentalRoute,
  AppLyricsRoute: AppLyricsRoute,
  AppMusicStylesRoute: AppMusicStylesRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSongReviewRoute: AppSongReviewRouteWithChildren,
  AppSongsRoute: AppSongsRouteWithChildren,
  AppUploadRoute: AppUploadRoute,
  PreviewFlashcardsRoute: PreviewFlashcardsRouteWithChildren,
  PreviewInstrumentalRoute: PreviewInstrumentalRoute,
  PreviewLyricsRoute: PreviewLyricsRoute,
  PreviewSongsRoute: PreviewSongsRoute,
  AppDecksDeckIdRoute: AppDecksDeckIdRoute,
  AppDecksAddRoute: AppDecksAddRoute,
  AppEsBasicCreateRoute: AppEsBasicCreateRoute,
  AppScheduleAnalyticsRoute: AppScheduleAnalyticsRoute,
  AppScheduleCalendarRoute: AppScheduleCalendarRoute,
  AppScheduleReviewRoute: AppScheduleReviewRoute,
  PreviewDecksAddRoute: PreviewDecksAddRoute,
  PreviewScheduleCalendarRoute: PreviewScheduleCalendarRoute,
  AppDecksIndexRoute: AppDecksIndexRoute,
  AppScheduleIndexRoute: AppScheduleIndexRoute,
  PreviewDecksIndexRoute: PreviewDecksIndexRoute,
  PreviewScheduleIndexRoute: PreviewScheduleIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
